var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCool = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.61394 1.41421L6.02815 0L7.32104 1.29289L8.61394 0L10.0282 1.41421L8.32109 3.12127V5.97495L10.7925 4.54811L11.4173 2.21622L13.3491 2.73386L12.8759 4.49998L14.642 4.97322L14.1244 6.90507L11.7924 6.28021L9.32101 7.70705L11.7925 9.13394L14.1243 8.50911L14.642 10.441L12.8759 10.9142L13.3491 12.6803L11.4172 13.198L10.7924 10.8659L8.32109 9.43915V12.2929L10.0282 14L8.61394 15.4142L7.32104 14.1213L6.02815 15.4142L4.61394 14L6.32109 12.2928V9.43905L3.84965 10.8659L3.22479 13.198L1.29294 12.6803L1.76617 10.9142L4.57764e-05 10.441L0.517684 8.50911L2.84957 9.13393L5.32101 7.70705L2.84965 6.28021L0.517637 6.90507L0 4.97322L1.76612 4.49999L1.29289 2.73387L3.22474 2.21623L3.84957 4.54812L6.32109 5.97505V3.12137L4.61394 1.41421Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCool, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cool.026f1d25.svg";
export { ForwardRef as ReactComponent };